import styled from 'styled-components'

interface Props {
  hide?: boolean
}

export const WrapperWithHide = styled.div.withConfig<Props>({
  shouldForwardProp: (prop) => !prop.includes('hide'),
})`
  display: ${({ hide }: Props) => (hide ? 'none' : 'initial')};
`
